'use client';

interface TermItem {
  title: string;
  content: string | string[];
}

interface TermsOfServiceSectionProps {
  title: string;
  items: TermItem[];
}

export default function TermsOfServiceSection({ title, items }: TermsOfServiceSectionProps) {
  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16 space-y-4">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-headline font-bold text-foreground">
            {title}
          </h2>
          <p className="text-lg text-muted-foreground font-body leading-relaxed">
            Please read these terms carefully as they govern your use of our services and your enrollment in our programs.
          </p>
        </div>
        
        <div className="space-y-8">
          {items.map((item, index) => (
            <div
              key={index}
              className="bg-card rounded-xl p-8 shadow-sky-sm hover:shadow-sky-md transition-all duration-300"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center h-10 w-10 rounded-lg bg-gradient-to-br from-primary to-accent">
                    <span className="text-sm font-headline font-bold text-primary-foreground">
                      {index + 1}
                    </span>
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-headline font-bold text-foreground mb-4">
                    {item.title}
                  </h3>
                  {Array.isArray(item.content) ? (
                    <ul className="space-y-3">
                      {item.content.map((point, idx) => (
                        <li key={idx} className="flex gap-3 text-muted-foreground font-body leading-relaxed">
                          <span className="text-primary font-bold mt-1">•</span>
                          <span>{point}</span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-muted-foreground font-body leading-relaxed">
                      {item.content}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 bg-primary/10 border border-primary/20 rounded-xl">
          <p className="text-sm text-muted-foreground font-body">
            <span className="font-headline font-semibold text-foreground">Note: </span>
            By enrolling in our programs, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
          </p>
        </div>
      </div>
    </section>
  );
}
